import Header from '@/components/layout/Header'

const User = () => import(/* webpackChunkName: "user-group" */ '@/views/user/User')

export default [
  {
    path: '/user',
    name: 'user',
    components: {
      header: Header,
      main: User
    },
    meta: {
      title: '用户中心'
    }
  }
]
